module.exports = __webpack_public_path__ + "img/Competition Winners-1.ae4ee0d1.png";